import { METRIC_CATEGORY, DASHBOARD_DATA_SCOPE } from '@utils/constants';
import { MetricTypes, metricKeys } from '@pulse/metrics';
import { DIMENSION_TYPES_CONSTANTS } from '@utils/metrics';
import { DIMENSION_CATEGORY_KEYS } from '@src/utils/dimension/dimensionCategories';

export const ECO_PRESET_KEY = {
  APP_EVENTS: 'events',
  APP_NETWORK_PERFORMANCE: 'network-performance',
  APP_USER_EXPERIENCE: 'user-experience',
  APP_ANALYZE_ALERTS: 'analyze-alerts',
};

// Decouple the limitation with preset config as preset config will be persisted in the db
// This will give us more flexiblity to controll the behavior of preset.
const useCaseLimitation = {
  // User Experience - session scope
  [ECO_PRESET_KEY.APP_USER_EXPERIENCE]: {
    dataScope: DASHBOARD_DATA_SCOPE.SESSION,
    metrics: {
      excludeTypes: [MetricTypes.appEventMetrics],
      excludeKeys: [
        metricKeys.AverageRequestDuration,
        metricKeys.AverageRequestCount,
        metricKeys.EventsPerUserHour,
        metricKeys.AppTotalEventsLocal,
        metricKeys.AppTotalEvents,
      ],
      excludeCategories: [],
    },
    dimensions: {
      excludeTypes: [
        DIMENSION_TYPES_CONSTANTS.mappedEventName,
        DIMENSION_TYPES_CONSTANTS.eventTagKeyValueMetadata,
      ],
      excludeCategories: [DIMENSION_CATEGORY_KEYS.eco.event_tags],
    },
    summaryMetricPanel: {
      SPIWidget: {},
    },
    dimensionPanel: {
      networkRequestTab: {
        disabled: true,
      },
    },
  },
  // Events - event scope
  [ECO_PRESET_KEY.APP_EVENTS]: {
    dataScope: DASHBOARD_DATA_SCOPE.EVENT,
    metrics: {
      disableTemplateMetric: true,
      excludeTypes: [MetricTypes.appSpecificMetrics, MetricTypes.appEventMetrics],
      excludeKeys: [metricKeys.AverageRequestDuration, metricKeys.AverageRequestCount],
      excludeCategories: [
        METRIC_CATEGORY.eco.USER_DEFINED_METRICS,
        METRIC_CATEGORY.eco.USER_LOGIN,
        METRIC_CATEGORY.eco.SUBSCRIPTION,
        METRIC_CATEGORY.eco.QOE_AND_KPI_METRICS,
      ],
    },
    dimensions: {
      excludeCategories: [
        DIMENSION_CATEGORY_KEYS.eco.global_tags,
        DIMENSION_CATEGORY_KEYS.eco.network,
      ],
    },
    dimensionPanel: {
      networkRequestTab: {
        disabled: true,
      },
    },
    summaryMetricPanel: {
      SPIWidget: {
        disabled: true,
      },
    },
  },
  // Network Peformance - event scope
  [ECO_PRESET_KEY.APP_NETWORK_PERFORMANCE]: {
    dataScope: DASHBOARD_DATA_SCOPE.EVENT,
    metrics: {
      disableTemplateMetric: true,
      excludeTypes: [MetricTypes.appSpecificMetrics],
      excludeKeys: [
        metricKeys.AppTotalEvents,
        metricKeys.AppTotalUserEvents,
        metricKeys.EventsPerUserHour,
      ],
      excludeCategories: [
        METRIC_CATEGORY.eco.USER_DEFINED_METRICS,
        METRIC_CATEGORY.eco.USER_LOGIN,
        METRIC_CATEGORY.eco.SUBSCRIPTION,
        METRIC_CATEGORY.eco.QOE_AND_KPI_METRICS,
      ],
    },
    dimensions: {
      excludeCategories: [
        DIMENSION_CATEGORY_KEYS.eco.global_tags,
        DIMENSION_CATEGORY_KEYS.eco.events,
      ],
    },
    dimensionPanel: {
      networkRequestTab: {},
    },
    summaryMetricPanel: {
      SPIWidget: {
        disabled: true,
      },
    },
  },
};

export const getUseCaseLimitation = (usecaseKey: string) => {
  return useCaseLimitation[usecaseKey];
};
